// Arabic harakat/diacritics (fatha, damma, kasra, sukun, tanwin, superscript
// alef, and the less common quranic marks) — all visual, never meaningful for
// matching a place name.
const ARABIC_DIACRITICS = /[ؐ-ًؚ-ٰٟۖ-ۭ࣓-ࣣ࣡-ࣿ]/g;
// Tatweel/kashida — a stretching glyph, not a character.
const TATWEEL = /ـ/g;
// Alef variants (madda/hamza-above/hamza-below) unified to the bare alef.
const ALEF_VARIANTS = /[آأإٱ]/g;
// Alef maksura unified to ya.
const ALEF_MAKSURA = /ى/g;
// Ta marbuta unified to ha — the two are pronounced identically at the end of
// an Egyptian place name and are used interchangeably by buyers typing on a
// phone keyboard.
const TA_MARBUTA = /ة/g;
const INTERNAL_WHITESPACE = /\s+/g;
/**
 * Pure normalization used as the dedup key for `area_suggestions`
 * (`UNIQUE (governorate_id, normalized_name)`). No I/O, no injection — a
 * plain string transform so it can be unit-tested in isolation and reused
 * anywhere a raw buyer-typed area name needs to be compared.
 *
 * Order matters: diacritics/tatweel are stripped before letter unification so
 * a diacritic sitting on e.g. an alef variant doesn't survive the swap.
 */
export function normalizeAreaName(raw) {
    return raw
        .normalize('NFC')
        .replace(ARABIC_DIACRITICS, '')
        .replace(TATWEEL, '')
        .replace(ALEF_VARIANTS, 'ا')
        .replace(ALEF_MAKSURA, 'ي')
        .replace(TA_MARBUTA, 'ه')
        .toLowerCase()
        .replace(INTERNAL_WHITESPACE, ' ')
        .trim();
}
//# sourceMappingURL=area-name-normalizer.js.map